<template>
  <form>
    <slot />
  </form>
</template>

<script setup>
import { ref, provide } from "vue"

const validatedInputs = ref([])

/**
 * Allow descendant ValidatedInputComponent to attach to and detach from this
 * instance
 */
provide("attachToForm", (component) => {
  validatedInputs.value.push(component)
})

provide("detachFromForm", (component) => {
  const index = validatedInputs.value.indexOf(component)
  if (index > -1) {
    validatedInputs.value.splice(index, 1)
  }
})

/**
 * Call each attached ValidatedInputComponent's validate method
 */
function validate(scrollIfFailed = false) {
  let valid = true
  for (const component of validatedInputs.value) {
    if (component && typeof component.validate === "function") {
      valid = component.validate(scrollIfFailed) && valid
    }
  }
  return valid
}

defineExpose({
  validate,
})
</script>
